
import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children, allowedRoles }) {

    const role = sessionStorage.getItem("UserRole");

    // Not logged in
    if (!role) {
        return (
            <Navigate
                to="/lfploginadmin"
                replace
            />
        );
    }

    // Check role access
    if (
        allowedRoles &&
        !allowedRoles.includes(role)
    ) {

        // ADMIN goes to admin dashboard
        if (role === "ADMIN") {
            return (
                <Navigate
                    to="/dashboard-admin"
                    replace
                />
            );
        }

        // USER goes to user dashboard
        if (role === "USER") {
            return (
                <Navigate
                    to="/dashboard"
                    replace
                />
            );
        }

        // Unknown role
        return (
            <Navigate
                to="/lfploginadmin"
                replace
            />
        );
    }

    return children;
}

export default ProtectedRoute;
